'use strict';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import {Observable} from 'rxjs/Observable';
import {SortMethod} from '../../core-utilities/filters/SortMethod';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {updateLoadingModeSize} from '../../core-components/loading-icon/utils';
import {defaultFilterOptions} from '../redux/assetProjectConfig';
import filterTemplate from './asset-projects-filter.html';
import {logger} from './logger';


ProjectsAssetProjectsFilterMixin.$inject = [
  '$filter',
  'BaseFilterMixin',
];

export function ProjectsAssetProjectsFilterMixin(
  $filter,
  BaseFilterMixin,
) {
  return function ProjectsAssetProjectsFilter(vm, $scope) {
    const baseFilter = new BaseFilterMixin($scope, {
      cacheId: 'ProjectsAssetProjectsFilterMixin',
      controllerAs: 'assetProjectsList',
      filterTemplate: filterTemplate,
      defaultSortProperty: 'name',
      filterOptions: defaultFilterOptions,
      enablePagination: true,
    });

    return {
      size: baseFilter.size,
      updateLimit: baseFilter.updateRenderLimit,
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter),
    };

    function initFiltering(list) {
      if (!list || !isFunction(list.$toObservable)) {
        vm.filteredList = list;
        return;
      }
      baseFilter.registerFilter('filteredList');

      const list$ = list.$toObservable();

      const filteredList$ = Observable.combineLatest(
        list$,
        baseFilter.filterOptionsObservable,
        baseFilter.sortOptionsObservable,
        baseFilter.filterObservable,
        (list, filterOptions, sortOptions, autoFilter) => {
          const filtered = applyFilterOptions(list, vm.currentFilter.filterOptions || filterOptions);
          const sorted = applySortOptions(filtered, vm.currentFilter.sortOptions || sortOptions);
          return filterWithToString(sorted, autoFilter);
        })
        .catch(epicErrorHandler(logger, 'filteredList$'));

      baseFilter.activeSubscriptions.push(updateLoadingModeSize(list$, $scope, vm));

      baseFilter.activeSubscriptions.push(filteredList$.subscribe(baseFilter.updateFilter('filteredList', $scope)));
    }
  };

  function applyFilterOptions(list, options) {
    const result = [];

    try {
      for (const key in list) {
        if (list.hasOwnProperty(key)) {
          const project = list[key];

          if (project && project.isDeleting) continue;
          if (filterOnStatus(project, options)) continue;

          result.push(project);
        }
      }
    } catch (error) {
      // TODO: do something with this?
      // console.log('error with filterAssetsOptions', list, options, error);
    }

    return result;
  }

  function filterOnStatus(project, options) {
    // Assignment filters
    // TODO: convert to accept a task or date instead?
    const status = project ? project.status : null;

    if (!status) return false;

    if (status && !options.status[status]) return true;

    return false;
  }

  function applySortOptions(list, sortOptions) {
    const method = SortMethod.valueOf(sortOptions.currentMethod) || SortMethod.ASCENDING;
    return list.sort($filter.$sortByPropertyAccessor(getName, method.val, true));
  }

  function getName(assetProject) {
    return assetProject.toString();
  }

  function filterWithToString(list, query) {
    if (!query || !isString(query)) return list;

    query = lowercase(query);

    const result = [];

    for (let i = 0, length = list.length; i < length; i++) {
      const item = list[i];

      if (item && isObject(item)) {
        if (item && lowercase(item.toString()).indexOf(query) > -1) {
          result.push(item);
        } else if (item.asset && item.asset.identifier && lowercase(item.asset.identifier).indexOf(query) > -1) {
          result.push(item);
        }
      }
    }

    return result;
  }

  function lowercase(str) {
    return str ? str.toLowerCase() : str;
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/filters/ProjectsAssetProjectsFilterMixin.js